import { Check, Loader2, ArrowRight, Sparkles } from "lucide-react";
import { useCheckout } from "@/hooks/useMimis";

export const PLAN_INFO = {
  starter: {
    name: "Starter", price: 9,
    tagline: "Per iniziare a pubblicare con costanza.",
    features: ["10 video al mese", "Voce umana italiana", "Sottotitoli automatici", "Immagini AI o le tue 3 foto"],
  },
  pro: {
    name: "Pro", price: 19,
    tagline: "Per chi vuole il proprio marchio nei video.",
    features: ["Video illimitati", "Il nome della tua attività nel finale", "Tutto quello che c'è in Starter"],
  },
};

export const PlanButton = ({ plan, onClick, busy, dark = false }) => (
  <button
    onClick={() => onClick(plan)}
    disabled={!!busy}
    className={`${dark ? "btn-blu" : "btn-ghost"} mt-6 h-13 min-h-[3.25rem] w-full text-base`}
    data-testid={`choose-${plan}-button`}
  >
    {busy === plan ? <Loader2 className="h-5 w-5 animate-spin" /> : <>Scegli {PLAN_INFO[plan].name} {PLAN_INFO[plan].price}€ <ArrowRight className="arrow h-4 w-4" /></>}
  </button>
);

const PlanCard = ({ plan, start, busy }) => {
  const p = PLAN_INFO[plan];
  const pro = plan === "pro";
  return (
    <div className={`relative overflow-hidden rounded-[1.75rem] p-7 sm:p-8 ${pro ? "bg-[#111111] text-white shadow-[0_40px_80px_-40px_rgba(0,102,255,0.6)]" : "bg-white"}`} data-testid={`plan-card-${plan}`}>
      {pro && <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[#0066FF]/30 blur-2xl" />}
      <div className="relative flex flex-wrap items-center justify-between gap-3">
        <p className="font-display text-lg font-bold">{p.name}</p>
        {pro && (
          <span className="inline-flex items-center gap-1.5 rounded-full bg-[#0066FF] px-3 py-1.5 text-xs font-semibold text-white" data-testid="plan-pro-badge">
            <Sparkles className="h-3.5 w-3.5" /> Il più scelto
          </span>
        )}
      </div>
      <p className="relative mt-4 flex items-end gap-2">
        <span className="font-display text-6xl font-extrabold leading-none tracking-tighter" data-testid={`plan-price-${plan}`}>{p.price}€</span>
        <span className={`pb-1.5 text-sm font-medium ${pro ? "text-zinc-300" : "text-[#52525b]"}`}>al mese</span>
      </p>
      <p className={`relative mt-2 text-sm ${pro ? "text-zinc-300" : "text-[#52525b]"}`}>{p.tagline}</p>
      <ul className="relative mt-5 space-y-2.5">
        {p.features.map((f) => (
          <li key={f} className="flex items-center gap-3 text-[0.95rem]">
            <span className={`grid h-5 w-5 shrink-0 place-items-center rounded-full ${pro ? "bg-[#0066FF] text-white" : "bg-[#0066FF]/10 text-[#0066FF]"}`}><Check className="h-3 w-3" strokeWidth={3} /></span>
            {f}
          </li>
        ))}
      </ul>
      <PlanButton plan={plan} onClick={start} busy={busy} dark={pro} />
    </div>
  );
};

export const PriceCard = () => {
  const { start, busy } = useCheckout();
  return (
    <div className="space-y-5" data-testid="price-card">
      <PlanCard plan="starter" start={start} busy={busy} />
      <PlanCard plan="pro" start={start} busy={busy} />
      <p className="text-center text-xs text-[#52525b]">Pagamento sicuro con Stripe · Disdici quando vuoi · Accesso con Google</p>
    </div>
  );
};
